<template>
  <div class="container__content">
    <div class="wrapper">
      <div class="changltx-1">
        <div class="changltx-1__title"><span class="changltx-1__title__text">长龙提醒</span></div>
        <div class="changltx-1__content">
          <div class="changltx-1__content__sidebar">
            <div class="sidebar">
              <div class="sidebar__title">
                <span class="sidebar__title__text">选择彩种</span>
                <div class="sidebar__title__control">
                  <a class="button-outline" @click="handleAllItem(true)">
                    <span class="button-outline__text">全选</span>
                  </a>
                  <a class="button-outline" @click="handleAllItem(false)">
                    <span class="button-outline__text">取消</span>
                  </a>
                </div>
              </div>
              <div class="sidebar__content">
                <div v-for="(item, index) in cpyList" :key="index" class="sidebar__content__item">
                  <div class="ultitle" :class="{off: !item.isActive}">
                    <span class="ultitle__text" @click="item.isActive = !item.isActive">
                      {{ item.label }}
                      <i class="ultitle__text__subicon"></i>
                    </span>
                    <div class="ultitle__control">
                      <a class="button-outline" @click="handleItemByCategory(item.label, true)">
                        <span class="button-outline__text">全选</span>
                      </a>
                      <a class="button-outline" @click="handleItemByCategory(item.label, false)">
                        <span class="button-outline__text">取消</span>
                      </a>
                    </div>
                  </div>
                  <div v-show="item.isActive" class="libox">
                    <div v-if="item.label === '高频彩'" class="libox__control">
                      <div class="libox__control__item">
                        <span class="libox__control__item__text">类型</span>
                        <div class="selectbox">
                          <select v-model="cpType" class="selectbox__select" @change="filterGaopin">
                            <option value="">全部</option>
                            <option v-for="(type, key) in cpTypeForGaopin" :key="type" :value="key">{{ type }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="libox__control__item">
                        <span class="libox__control__item__text">地区</span>
                        <div class="selectbox">
                          <select v-model="cpPlace" class="selectbox__select" @change="filterGaopin">
                            <option value="">全部</option>
                            <option v-for="(place, key) in cpPlaceForGaopin" :key="place" :value="key">{{ place }}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="libox__content">
                      <div v-for="child in item.children" :key="child.lotteryCode" class="libox__content__item">
                        <div class="checkbox" :class="{active: child.isActive}" @click="handleItem(child)">
                          <i class="checkbox__select"></i>
                          <label class="checkbox__label" for="">{{ child.name }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="changltx-1__content__container">
            <div class="changltx-control">
              <div class="changltx-control__left">
                <div class="menubar">
                  <div class="menubar__item" :class="{active: activeMenuBar === '连续开出'}" @click="changeMenuBar">
                    <span class="menubar__item__text">连续开出</span>
                    <div class="menubar__item__lightborder"></div>
                  </div>
                  <div class="menubar__item" :class="{active: activeMenuBar === '连续未开'}" @click="changeMenuBar">
                    <span class="menubar__item__text">连续未开</span>
                    <div class="menubar__item__lightborder"></div>
                  </div>
                </div>
              </div>
              <div class="changltx-control__right"><span class="changltx-control__right__text">只显示连续</span>
                <div class="selectbox">
                  <select v-model="selectedNumber" class="selectbox__select" @change="getTableData(selectedNumber)">
                    <option v-for="num in 14" :key="num" :value="num + 1">{{ num + 1 }}</option>
                  </select>
                </div><span class="changltx-control__right__text">期及以上的长龙</span>
              </div>
            </div>
            <loading v-if="isLoading" />
            <div v-else class="changltx-table">
              <template v-if="changLongContinuousTable.length > 0 || changLongMissingTable.length > 0">
                <table>
                  <thead>
                    <tr>
                      <th><span>彩种</span></th>
                      <th><span>位置</span></th>
                      <th><span>{{ periodLabel }}</span></th>
                      <th><span>开奖信息</span></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in tableList" :key="index">
                      <td>
                        <span>{{ codeMappingName(item.code) }}</span>
                      </td>
                      <td>
                        <span>{{ item.fieldName }}{{ item.ruleTypeName }} : {{ item.ruleName }}</span>
                      </td>
                      <td>
                        <span>{{ activeMenuBar === '连续开出' ? item.continuous : item.missing }}</span>
                      </td>
                      <td>
                        <a class="button-outline" @click="goTo(item.code)">
                          <span class="button-outline__text">查看</span>
                        </a>
                      </td>
                    </tr>
                    <tr v-if="!noMoreData">
                      <td colspan="4">
                        <span class="button-primary c8-datebox__item active" @click="showMoreInfo">显示更多</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </template>
              <NoData v-else />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCpsList_desktop } from '@/api/desktop/basic'
import { getCpPlaceCode } from '@/api/public/basic'
import { lotteryTypeNameMapping } from '@/utils/steven/lotteryDictionary'
import { getChangLongContinuousList_desktop, getChangLongMissingList_desktop } from '@/api/desktop/changltx'
import Loading from '@/components/web/common/Loading'
import NoData from '@/components/web/common/NoData'
import chunk from 'lodash.chunk'
export default {
  name: 'Changltx',
  components: {
    Loading,
    NoData
  },
  data() {
    return {
      cpyList: [],
      selectedNumber: 2,
      changLongContinuousTable: [],
      changLongMissingTable: [],
      activeObject: {},
      lotteryCodeMapping: {},
      activeMenuBar: '连续开出',
      cpTypeForGaopin: {},
      cpPlaceForGaopin: {},
      cpType: 'k3',
      cpPlace: '',
      defaultGaopinCpyList: [],
      isLoading: false,
      chunkInfo: {
        lists: [],
        index: 0,
        total: 0,
        isLast: false
      }
    }
  },
  computed: {
    noMoreData() {
      return this.chunkInfo.isLast
    },
    periodLabel() {
      return this.activeMenuBar === '连续开出' ? '连续开出期数' : '连续未开出期数'
    },
    tableList() {
      return this.activeMenuBar === '连续开出' ? this.changLongContinuousTable : this.changLongMissingTable
    }
  },
  async created() {
    await this.getCpsList()
    await this.getDefaultActiveItem()
    await this.getLotteryName()
    await this.getTableData(2)

    this.getGaopinCpType()
    this.getGaopinCpPlace()
    this.filterGaopin()
  },
  methods: {
    async getCpsList() {
      let jisuCps, gaopinCps, localCps, chinaCps
      let jisuCpsError = null
      let gaopinCpsError = null
      let localCpsError = null
      let chinaCpsError = null

      jisuCps = getCpsList_desktop('jisu')
      gaopinCps = getCpsList_desktop('gaopin')
      localCps = getCpsList_desktop('local')
      chinaCps = getCpsList_desktop('china');

      [
        [jisuCps, jisuCpsError],
        [gaopinCps, gaopinCpsError],
        [localCps, localCpsError],
        [chinaCps, chinaCpsError]
      ] = await Promise.all([jisuCps, gaopinCps, localCps, chinaCps])
      if (jisuCpsError || gaopinCpsError || localCpsError || chinaCpsError) {
        return
      }

      jisuCps = jisuCps.filter(item => item.dragonEnable === 1)
      gaopinCps = gaopinCps.filter(item => item.dragonEnable === 1)
      localCps = localCps.filter(item => item.dragonEnable === 1)
      chinaCps = chinaCps.filter(item => item.dragonEnable === 1)

      this.defaultGaopinCpyList = gaopinCps.map(item => {
        return (({ name, code: lotteryCode, placeCode = '', cpType, isActive = false }) => ({ name, lotteryCode, placeCode, cpType, isActive }))(item)
      })

      this.cpyList = [{
        label: '极速彩',
        children: jisuCps,
        isActive: true
      }, {
        label: '高频彩',
        children: gaopinCps,
        isActive: true
      }, {
        label: '地方彩',
        children: localCps,
        isActive: true
      }, {
        label: '全国彩',
        children: chinaCps,
        isActive: true
      }].reduce((array, group) => {
        group.children = group.children.map((child) => {
          return (({ name, code: lotteryCode, placeCode = '', cpType, isActive = false }) => ({ name, lotteryCode, placeCode, cpType, isActive }))(child)
        })
        return array.concat(group)
      }, [])
    },
    getDefaultActiveItem() {
      this.cpyList[0].children.forEach((child, index) => {
        if (index === 0 || index === 1 || index === 2) {
          child.isActive = true
          this.activeObject[child.lotteryCode] = child.isActive
        }
      })
    },
    handleAllItem(boolean) {
      this.cpyList.forEach(item => {
        item.children.forEach(child => {
          if (boolean) child.isActive = true
          else child.isActive = false
          this.activeObject[child.lotteryCode] = child.isActive
        })
      })
      this.getTableData(2)
    },
    handleItemByCategory(name, boolean) {
      this.cpyList.forEach(item => {
        if (item.label !== name) return
        item.children.forEach(child => {
          if (boolean) {
            child.isActive = true
          } else {
            child.isActive = false
          }
          this.activeObject[child.lotteryCode] = child.isActive
        })
        this.getTableData(2)
      })
    },
    handleItem(item) {
      item.isActive = !item.isActive
      this.activeObject[item.lotteryCode] = item.isActive
      this.getTableData(2)
    },
    async getTableData(num) {
      this.isLoading = true
      const activeList = []
      for (const code in this.activeObject) {
        if (this.activeObject[code]) activeList.push(code)
      }
      if (activeList.length > 0) {
        const codeListToString = activeList.join()
        const continusQuery = {
          continuous: num,
          code: codeListToString
        }
        const missingQuery = {
          missing: num,
          code: codeListToString
        }

        const changLongContinuous = getChangLongContinuousList_desktop(continusQuery)
        const changLongMissing = getChangLongMissingList_desktop(missingQuery)

        const [
          [changLongContinuousList, changLongContinuousListError],
          [changLongMissingList, changLongMissingListError]
        ] = await Promise.all([changLongContinuous, changLongMissing])

        if (changLongContinuousListError || changLongMissingListError) {
          console.error(`连续开出出错误`, changLongContinuousListError)
          console.error(`连续未开出错误`, changLongMissingListError)
        }

        if (this.activeMenuBar === '连续开出') {
          Object.assign(this.chunkInfo, this.chunkData(changLongContinuousList))
          this.changLongContinuousTable = this.chunkInfo.lists[this.chunkInfo.index] || []
        }

        if (this.activeMenuBar === '连续未开') {
          Object.assign(this.chunkInfo, this.chunkData(changLongMissingList))
          this.changLongMissingTable = this.chunkInfo.lists[this.chunkInfo.index] || []
        }
      } else {
        this.changLongContinuousTable = []
        this.changLongMissingTable = []
      }
      this.isLoading = false
    },
    chunkData(data) {
      const lists = chunk(data, 30)
      const index = 0
      const total = lists.length - 1
      const isLast = index === total
      return { lists, index, total, isLast }
    },
    showMoreInfo() {
      const { total, lists } = this.chunkInfo
      this.chunkInfo.index++
      if (this.chunkInfo.index === total) {
        this.chunkInfo.isLast = true
      }
      if (this.activeMenuBar === '连续开出') {
        this.changLongContinuousTable = this.changLongContinuousTable.concat(lists[this.chunkInfo.index])
      }
      if (this.activeMenuBar === '连续未开') {
        this.changLongMissingTable = this.changLongMissingTable.concat(lists[this.chunkInfo.index])
      }
    },
    changeMenuBar() {
      this.activeMenuBar === '连续开出' ? this.activeMenuBar = '连续未开' : this.activeMenuBar = '连续开出'
      this.getTableData(2)
    },
    async getLotteryName() {
      const [getLotteryNameMapping, error] = await this.$store.dispatch('lottery/getLotteryNameMapping')
      if (error) return
      this.lotteryCodeMapping = getLotteryNameMapping
    },
    codeMappingName(code) {
      return this.lotteryCodeMapping[code]
    },
    getGaopinCpType() {
      this.cpyList[1].children
        .map(item => item.cpType)
        .filter((ele, index, arr) => arr.indexOf(ele) === index)
        .forEach(lotteryType => {
          this.cpTypeForGaopin[lotteryType] = lotteryTypeNameMapping[lotteryType]
        })
    },
    async getGaopinCpPlace() {
      const [cpPlace, error] = await getCpPlaceCode()
      if (error) return
      this.cpPlaceForGaopin = cpPlace
    },
    async filterGaopin() {
      this.cpyList[1].children = this.defaultGaopinCpyList
      this.cpyList[1].children = this.cpyList[1].children.filter(item => {
        const type = item.cpType === this.cpType
        const typeEmpty = this.cpType === ''

        const placeCode = item.placeCode === this.cpPlace
        const placeCodeEmpty = this.cpPlace === ''

        return (type || typeEmpty) && (placeCode || placeCodeEmpty)
      })
    },
    goTo(code) {
      this.$router.push(`/lottery/trend/${code}`)
    }
  }
}
</script>
